// src/pages/user/Notifications.js
// Page notifications avec état réel de la permission de l'appareil - NE PAS MODIFIER

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useTheme } from '../../hooks/useTheme';

const Notifications = () => {
  const navigate = useNavigate();
  const { theme } = useTheme();

  const [notifStatus, setNotifStatus] = useState('checking');

  useEffect(() => {
    if (!('Notification' in window)) {
      setNotifStatus('unsupported');
      return;
    }
    setNotifStatus(Notification.permission);
  }, []);

  const handleActivate = async () => {
    if (notifStatus !== 'default') return;
    const result = await Notification.requestPermission();
    setNotifStatus(result);
  };

  const statusConfig = {
    granted: { label: 'Activées', color: '#48BB78', icon: '✅' },
    denied: { label: 'Bloquées', color: '#F56565', icon: '🚫' },
    default: { label: 'Non activées', color: theme.textMuted, icon: '🔕' },
    unsupported: { label: 'Non disponibles sur cet appareil', color: theme.textMuted, icon: '⚠️' },
    checking: { label: '...', color: theme.textMuted, icon: '🔔' },
  };
  const current = statusConfig[notifStatus] || statusConfig.checking;

  const styles = {
    container: { display: 'flex', flexDirection: 'column', minHeight: '100vh', backgroundColor: theme.bg },
    header: { display: 'flex', alignItems: 'center', gap: '12px', padding: '16px', position: 'sticky', top: 0, backgroundColor: theme.bg, zIndex: 50, borderBottom: `1px solid ${theme.borderSoft}` },
    backButton: { background: 'none', border: 'none', color: theme.textPrimary, fontSize: '20px', cursor: 'pointer', padding: '4px' },
    title: { fontSize: '20px', fontWeight: '700', color: theme.textPrimary },
    statusCard: {
      margin: '16px', padding: '20px', backgroundColor: theme.bgCard, borderRadius: '16px',
      border: `1px solid ${theme.border}`, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px', textAlign: 'center',
    },
    statusIcon: { fontSize: '36px' },
    statusLabel: { fontSize: '16px', fontWeight: '700', color: current.color },
    statusDesc: { fontSize: '13px', color: theme.textSecondary, maxWidth: '280px', lineHeight: '1.5' },
    activateBtn: {
      marginTop: '6px', padding: '12px 28px', backgroundColor: theme.gold, border: 'none',
      borderRadius: '10px', color: '#FFFFFF', fontSize: '14px', fontWeight: '700', cursor: 'pointer',
    },
    settingsLink: { fontSize: '13px', color: theme.gold, fontWeight: '600', cursor: 'pointer', marginTop: '4px' },
    emptyContainer: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '40px 24px', textAlign: 'center', gap: '12px' },
    emptyIcon: { fontSize: '48px', opacity: 0.4 },
    emptyTitle: { fontSize: '16px', fontWeight: '600', color: theme.textPrimary },
    emptyText: { fontSize: '14px', color: theme.textSecondary, maxWidth: '280px', lineHeight: '1.5' },
  };

  return (
    <div style={styles.container}>
      <Helmet>
        <title>Notifications | Fynho</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div style={styles.header}>
        <button style={styles.backButton} onClick={() => navigate(-1)}>←</button>
        <div style={styles.title}>🔔 Notifications</div>
      </div>

      <div style={styles.statusCard}>
        <div style={styles.statusIcon}>{current.icon}</div>
        <div style={styles.statusLabel}>{current.label}</div>
        <div style={styles.statusDesc}>
          {notifStatus === 'granted' && "Vous recevrez les alertes de Fynho sur cet appareil dès que cette fonctionnalité sera disponible."}
          {notifStatus === 'default' && "Activez les notifications pour être alerté des mises à jour de vos favoris et demandes."}
          {notifStatus === 'denied' && "Vous avez bloqué les notifications pour Fynho. Réactivez-les depuis les réglages de votre navigateur."}
          {notifStatus === 'unsupported' && "Votre navigateur ne prend pas en charge les notifications."}
        </div>

        {notifStatus === 'default' && (
          <button style={styles.activateBtn} onClick={handleActivate}>Activer</button>
        )}
        {notifStatus === 'denied' && (
          <span style={styles.settingsLink} onClick={() => navigate('/settings')}>Aller aux paramètres →</span>
        )}
      </div>

      <div style={styles.emptyContainer}>
        <div style={styles.emptyIcon}>📭</div>
        <div style={styles.emptyTitle}>Aucune notification pour l'instant</div>
        <div style={styles.emptyText}>
          Vos futures notifications concernant vos favoris et demandes apparaîtront ici.
        </div>
      </div>
    </div>
  );
};

export default Notifications;